import { IonApp, IonContent, IonRefresher, IonRefresherContent, IonSelect, IonSelectOption } from "@ionic/react";
import React, { Component } from "react";
import Toolbar from "../../components/Toolbar";
import Footer from "../../components/Footer";
import Leadboard from "../../components/Leadboard";
import Firebase from "../../firebase";
import "./style.css";
import { refreshOutline } from "ionicons/icons";
import { sortByProp } from "../../calcScore";

declare const document;

class Home extends Component {
  state = {
    fb: Firebase.getInstance(),
    uid: "",
    users: {} as any,
    usersSort: [] as any,
    data: {} as any,
    tournamentID: "",
    gameID: "total",
    isEditor: false,
  };

  _isMounted = true;

  componentWillUnmount() {
    this._isMounted = false;
  }

  async componentDidMount() {
    document.dispatchEvent(new Event("pageMount"));
    var data = await this.state.fb.readData("data");
    console.log(data);
    data.T = [, { txt: 1 }, { txt: 2 }];

    if (!this._isMounted) return;
    await this.setState({ data });
    await this.getData();

    var timer = setInterval(() => {
      if (this.updateCrown()) {
        setTimeout(() => {
          clearInterval(timer);
          setInterval(() => {
            this.updateCrown();
          }, 2000);
        }, 1000);
      }
    }, 100);

    const myUser = await this.state.fb.getUser();
    if (!this._isMounted) return;
    this.setState({ uid: myUser ? myUser.uid : "" });

    const myBets: any =
      this.state.users[this.state.uid] &&
      this.state.users[this.state.uid].bets &&
      Object.values(this.state.users[this.state.uid].bets);
    const lastTournament = myBets && data.Games[myBets[myBets.length - 1].gameID].tournamentID;
    const optionElements = document.getElementsByClassName("home__selectTournamentOption");
    (document.getElementById("selectTournament") as any).value = data.Tournaments[lastTournament]
      ? lastTournament
      : optionElements[optionElements.length - 1].value;

    this.setState({ isEditor: await this.state.fb.isEditor() });
  }

  getData = async () => {
    const users = await this.state.fb.readData("users/public");
    this.setState({ users });
  };

  updateCrown = () => {
    const crown: any = document.getElementById("leadboard__crown");
    const list: any = document.getElementsByClassName("leadboard__list")[0];
    if (!crown) return false;
    crown.style.display = list ? "block" : "none";
    if (!list) return false;
    crown.style.right = 0;
    // crown.style.marginTop = 0;
    const crownBox = crown.getBoundingClientRect();
    const listBox = list.getBoundingClientRect();
    const diff = crownBox.left - listBox.right + 40;
    crown.style.right = diff + "px";
    crown.style.marginTop = "-17px";
    return true;
  };

  render() {
    return (
      <IonApp>
        <Toolbar />
        <IonContent>
          <IonRefresher
            slot="fixed"
            pullMin={30}
            onIonRefresh={async (event: any) => {
              await this.getData();
              event.detail.complete();
            }}
          >
            <IonRefresherContent pullingIcon={refreshOutline} refreshingSpinner="crescent"></IonRefresherContent>
          </IonRefresher>
          <br />
          <IonSelect
            id="selectTournament"
            placeholder="בחירת טורניר"
            interface="popover"
            className="myteam__selectGame"
            onIonChange={(e: any) => {
              this.setState({ tournamentID: e.detail.value });
            }}
          >
            {this.state.data.Tournaments &&
              /*sortByProp(this.state.data.Tournaments, "tournamentID", false)*/ Object.values(
                this.state.data.Tournaments
              ).map((tournamentValue: any, tournamentIndex: any) => {
                if (tournamentValue)
                  return (
                    <IonSelectOption
                      class="home__selectTournamentOption"
                      value={tournamentValue.tournamentID}
                      key={"tournament" + tournamentIndex}
                    >
                      {tournamentValue.tournamentDesc}
                    </IonSelectOption>
                  );
              })}
          </IonSelect>
          <br />
          <div className="home__message">{this.state.data.Misc?.homeMsg}</div>
          <div className="home__message">
            {this.state.data.Tournaments && this.state.data.Tournaments[this.state.tournamentID]?.homeMsg}
          </div>
          <br />
          <img
            id="leadboard__crown"
            alt=""
            className="leadboard__crown"
            src="assets/imgs/crown-100x59.png"
            style={{ display: "none" }}
          />
          <Leadboard
            data={this.state.data}
            users={this.state.users}
            tournamentID={this.state.tournamentID}
            gameID={this.state.gameID}
            rowsNum={10}
            uid={this.state.uid}
            isEditor={this.state.isEditor}
          />
          <br />
          <Footer />
        </IonContent>
      </IonApp>
    );
  }
}

export default Home;
